import {elementClosest} from "@wix/devzai-utils-dom";
import {assertNotNullable, Nullable} from "@wix/devzai-utils-common";

export const BymoPageActionHtmlElementAttribute = 'data-bymo-page-action-id' as const;
export const BymoPageHtmlElementContextMenuTargetAttribute = 'data-bymo-page-element-context-menu-target' as const;

/**
 * @deprecated use bymoPageElementGetContainingActionInfo instead
 */
export function bymoPageElementGetContainingActionElement (element: Element) {
    return elementClosest(element, `[${BymoPageActionHtmlElementAttribute}]`, true) as HTMLElement | null;
}

/**
 * @deprecated use bymoPageElementGetContainingActionInfo instead
 */
export function bymoPageElementGetContainingActionId (element: Element) {
    return bymoPageElementGetContainingActionElement(element)?.getAttribute(BymoPageActionHtmlElementAttribute)
}

export function bymoPageElementGetContainingActionInfo (element: Nullable<Element>) {

    if (element) {
        const actionElement = elementClosest(element, `[${BymoPageActionHtmlElementAttribute}]`, true) as HTMLElement | null;
        if (actionElement) {
            return {
                actionElement: actionElement,
                actionId: assertNotNullable(actionElement.getAttribute(BymoPageActionHtmlElementAttribute))
            }
        }
    }

    return null;
}